function setMyCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getMyCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkMyCookie(cname) {
  let myCookieValue = getMyCookie(cname);
  if (myCookieValue != "") {
    return true;
  }
  return false;
}

function showWelcomeModal(welcomeModalBlock, delay) {
  setTimeout(() => {
    welcomeModalBlock.style.display = "block";
    console.log("TIMEOUT MODAL");
  }, delay); // 👈️ delay in milliseconds
}

// Get the modal
var welcomeModal = document.getElementById("welcome-modal-popup-wrap");
// Get the <span> element that closes the modal
var welcomeClose = document.getElementById("welcome-modal-popup__close");

// When the user clicks on <span> (x), close the modal
welcomeClose.onclick = function () {
  welcomeModal.style.display = "none";
};
// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == welcomeModal) {
    welcomeModal.style.display = "none";
  }
};

const welcomeModalIsset = checkMyCookie("welcomeModal");
if (!welcomeModalIsset) {
  const delayWelcomeModal = 8000;
  const countAlreadyShown = getMyCookie("welcomeModalCount");
  switch (countAlreadyShown) {
    case "":
      setMyCookie("welcomeModal", "1", 0.5);
      setMyCookie("welcomeModalCount", "1", 30);
      showWelcomeModal(welcomeModal, delayWelcomeModal);
      break;
    case "1":
      setMyCookie("welcomeModal", "1", 30);
      setMyCookie("welcomeModalCount", "2", 30);
      showWelcomeModal(welcomeModal, delayWelcomeModal);
      break;
    case "2":
    default:
    // do nothing until destroyed
  }
}
